import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";
import commonReducer from "../common/state";
import dashboardReducer from "../blog/dashboard/state";
import dashboardSaga from "../blog/dashboard/state/saga";
import searchReducer from "../blog/nickname/search/state";
import searchSaga from "../blog/nickname/search/state/saga";
import mainReducer from "../blog/nickname/blog/state";
import mainSaga from "../blog/nickname/blog/state/saga";
import writeReducer from "../blog/write/state";
import writeSaga from "../blog/write/state/saga";
import authReducer from "../blog/auth/state";
import authSaga from "../blog/auth/state/saga";
import postReducer from "../blog/nickname/post/state";
import postSaga from "../blog/nickname/post/state/saga";
import seriesReducer from "../blog/nickname/series/state";
import seriesSaga from "../blog/nickname/series/state/saga";
import likeReducer from "../blog/nickname/like/state";
import likeSaga from "../blog/nickname/like/state/saga";
import tempReducer from "../blog/nickname/temp/state";
import tempSaga from "../blog/nickname/temp/state/saga";
import settingReducer from "../blog/setting/state";
import settingSaga from "../blog/setting/state/saga";

const reducer = combineReducers({
  common: commonReducer,
  dashboard: dashboardReducer,
  search: searchReducer,
  main: mainReducer,
  write: writeReducer,
  auth: authReducer,
  post: postReducer,
  series: seriesReducer,
  like: likeReducer,
  temp: tempReducer,
  setting: settingReducer,
});
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers =
  window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

function* rootSaga() {
  yield all([dashboardSaga(), searchSaga(), mainSaga(), writeSaga(), authSaga(), postSaga(), seriesSaga(), likeSaga(), tempSaga(), settingSaga()]);
}
sagaMiddleware.run(rootSaga);

export default store;
